window.addEventListener('scroll', function() {
  // Seleciona a linha do logo apenas na página de produto
  const logoRow = document.querySelector('.template-product .header__row--desktop-logo-only');

  if (window.scrollY > 50) {
    if (logoRow) {
      logoRow.style.display = 'none';
    }
  } else {
    if (logoRow) {
      logoRow.style.display = 'flex'; // Usamos flex porque é o padrão do Stiletto
    }
  }
});

/* ============================================================
   CRO — Mobile PDP gallery (2026-07-16)
   The gallery height/peek is controlled purely in custom.css by
   narrowing the .swiper width (see .product__media-container.below-mobile
   .swiper{width:...vw}). We do NOT change Swiper's slidesPerView here —
   post-init slidesPerView changes are ignored by this theme's Swiper.
   This just nudges Swiper to re-measure the (CSS-narrowed) swiper so
   slide widths/positions stay correct. Mobile only.
   ============================================================ */
(function(){
  function u(){
    if(!window.matchMedia('(max-width:749px)').matches){ return; }
    var el=document.querySelector('.product__media-container.below-mobile .swiper');
    if(el&&el.swiper){ try{ el.swiper.update(); }catch(e){} }
  }
  window.addEventListener('load', u);
  setTimeout(u,600); setTimeout(u,1500);
  window.addEventListener('resize', function(){ setTimeout(u,250); });
})();
